const DESKTOP_MODE_PARAM = 'desktop';
const DESKTOP_MODE_VALUE = '1';
const DESKTOP_USER_AGENT_TOKEN = 'GalaxyAccessDesktop';
const DESKTOP_MODE_SESSION_KEY = 'galaxyAccessDesktopMode';
const DESKTOP_EXACT_ROUTES = new Set([
  '/login',
  '/',
  '/internal-chat',
  '/internal-teams',
  '/settings',
  '/settings/reports',
  '/profile',
  '/admin-portal',
]);
const DESKTOP_ADMIN_PORTAL_SECTIONS = new Set(['number-porting', 'hosted-sms']);

const normalizeDesktopPath = (value) => {
  const path = String(value || '').trim().split(/[?#]/, 1)[0] || '/';
  if (path === '/') return path;
  return `/${path.replace(/^\/+|\/+$/g, '')}`;
};

const isAllowedAdminPortalChildRoute = (path) => {
  const segments = path.split('/').filter(Boolean);
  return (
    segments[0] === 'admin-portal'
    && DESKTOP_ADMIN_PORTAL_SECTIONS.has(segments[1])
    && (segments.length === 2 || segments.length === 3)
  );
};

const hasDesktopUserAgent = () => (
  typeof window !== 'undefined'
  && String(window.navigator?.userAgent || '').includes(DESKTOP_USER_AGENT_TOKEN)
);

const hasDesktopQueryParam = () => {
  if (typeof window === 'undefined') return false;

  try {
    return new URLSearchParams(window.location.search).get(DESKTOP_MODE_PARAM) === DESKTOP_MODE_VALUE;
  } catch (error) {
    return false;
  }
};

export const isDesktopMode = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  if (hasDesktopUserAgent()) {
    if (hasDesktopQueryParam()) {
      window.sessionStorage?.setItem(DESKTOP_MODE_SESSION_KEY, DESKTOP_MODE_VALUE);
    }

    return true;
  }

  return false;
};

export const isDesktopRouteAllowed = (pathname) => {
  const path = normalizeDesktopPath(pathname);
  return DESKTOP_EXACT_ROUTES.has(path) || isAllowedAdminPortalChildRoute(path);
};

export const isDesktopNavigationPathAllowed = (pathname) => {
  const path = normalizeDesktopPath(pathname);
  return path !== '/' && path !== '/login' && isDesktopRouteAllowed(path);
};

export const getDesktopRouteRedirect = (pathname, { desktopMode, isAuthenticated } = {}) => {
  if (!desktopMode || isDesktopRouteAllowed(pathname)) return null;
  return isAuthenticated ? '/internal-chat' : '/login';
};
